module.exports = "/_next/static/images/OgEvents-d49a5318fa727a13f223d8604c3269af.jpg";